/*
 *  Document   : exapoint.js
 *  Author     : Exapoint
 *  Description: Main entry point
 *
 */

// Import global dependencies

// Import required modules
import ExaTemplate from './exa_template';

// App extends Template
export default class ExaApp extends ExaTemplate {
    /*
     * Auto called when creating a new instance
     *
     */
    constructor() {
        super();
    }

}

// Once everything is loaded
jQuery(() => {
    // Create a new instance of App
    window.Exa = new ExaApp();
});
